// Module
var code = `<i class="fa fa-info-circle text-primary clickable" ng-class="tagPopoverController.viewClasses" ng-click="tagPopoverController.stop(\$event)" ng-if="tagPopoverController.tags.length > 0" uib-popover-template="'tags.popover.html'" popover-placement="bottom-left" popover-append-to-body="true"> </i> ${"<" + "script"} type="text/ng-template" id="tags.popover.html"> <dl class="m-b-0">
    <dt ng-repeat-start="tag in tagPopoverController.tags_ track by tag.name">{{ tag.label }}</dt>
    <dd ng-repeat-end>{{ tag.value }}</dd>
  </dl> ${"<" + "/script"}> `;
// Exports
module.exports = code;